import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NetworkService } from '../../core/services/network.service';

@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class SearchResultComponent implements OnInit {
    searchRequest: string;
    searchResults;
    isLoading = true;
    constructor(private route: ActivatedRoute,
                private networkService: NetworkService,
                private router: Router) {}

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.isLoading = true;
            this.searchRequest = params['src'];
            this.networkService.searchForProduct(params)
                .then((response) => {
                if (response.length) {
                    this.searchResults = response
                } else {
                    this.searchResults = null;
                }
                this.isLoading = false;
            })
        });

    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/search/search-result.component.ts